import { createContext, useContext } from 'react';

/**
 * Gift your teacher state for the owner's My Draft page:
 * { showBanner, examState, dismissBanner, openThankDialog, giftMonths,
 * thanksCredits }. The default is null and
 * the banner slot renders nothing then — always the case with the build flag
 * off, outside a My Draft, or for anyone who isn't a gift-eligible student.
 */
export const TeacherGiftContext = createContext(null);

export const useTeacherGift = () => useContext(TeacherGiftContext);
